export const ON_TOGGLE_ASIDE = "ON_TOGGLE_ASIDE";